import { sendRequest, HttpMethods } from "../util/ApiHelper";

const CONTROLLER_NAME = "QueryDesigner";

export interface GetListofFiltersParams {
  moduleName: string;
  includeValidValues?: boolean;
  windowName?: string;
}

export const getListofFilters = async (parameters: GetListofFiltersParams) => {
  return await sendRequest(
    HttpMethods.GET,
    `${CONTROLLER_NAME}/GetListofFilters`,
    {},
    {
      IncludeValidValues: parameters.includeValidValues ? "true" : "false",
      moduleName: parameters.moduleName,
      windowName: parameters.windowName ?? "",
    }
  );
};

export interface GetValueSearchDetailsParams {
  tableName: string;
  columnName: string;
}

export const getValueSearchDetails = async (
  params: GetValueSearchDetailsParams
) => {
  return await sendRequest(
    HttpMethods.GET,
    `${CONTROLLER_NAME}/GetValueSearchDetails`,
    {},
    params
  );
};

type TypeAheadValueDetailsParams = {
  tableName: string;
  columnName: string;
  query: string;
};

export const typeAheadValueDetails = async (
  params: TypeAheadValueDetailsParams
) => {
  return await sendRequest(
    HttpMethods.GET,
    `${CONTROLLER_NAME}/TypeAheadValueDetails`,
    {},
    { ...params, start: 0, limit: 26 }
  );
};
